/* globals initialContactMeState */
import $ from "jquery";
import 'bootstrap/js/dist/modal';

$('#btnContactMe').click(function () {
	$('#contactMeModal').modal('show');
});

$(document).ready(function () {
	loadForm();

	$('#btnSubmit').click(function () {
		if ($('#comments').val().match(/^\s*$/) !== null) {
			alert('The comments field is required.');
			return;
		}

		$('#bodyForm').hide();
		$('#btnSubmit').prop('disabled', 'disabled');
		$('#btnCancel').prop('disabled', 'disabled');
		$('#bodyLoading').show();

		var data = {
			CampaignId: initialContactMeState.CampaignId,
			CampaignOwnerId: initialContactMeState.CampaignOwnerId,
			FirstName: $('#first').val(),
			LastName: $('#last').val(),
			Email: $('#email').val(),
			Phone: $('#phone').val(),
			Organization: $('#org').val(),
			Help: $('#help').val(),
			Comments: $('#comments').val(),
			SalesforcePhone: $('#sfPhone').val(),
			PageURL: initialContactMeState.PageURL,
			SolutionName: initialContactMeState.SolutionName
		};

		$.ajax({
			type: 'POST',
			data: JSON.stringify(data),
			url: '/api/try/save-contact-us-form',
			contentType: 'application/json',
			success: function () {
				alert('The form was submitted successfully.');
				$('#contactMeModal').modal('hide');
				loadForm();

			},
			error: function () {
				alert('There was an error submitting the form. Please try again.');
				$('#contactMeModal').modal('hide');
				loadForm();

			}
		})
	});

	$('#btnSend').click(function () {
		alert('hello');
		if ($('#comments').val().match(/^\s*$/) !== null) {
			alert('The comments field is required.');
			return;
		}

		$('#bodyForm').hide();
		$('#btnSubmit').prop('disabled', 'disabled');
		$('#btnCancel').prop('disabled', 'disabled');
		$('#bodyLoading').show();

		var data = {
			DisplayName: $('#firstName').val() + ' ' + $('#lastName').val(),
			Email: $('#email').val(),
			Phone: $('#phone').val(),
			Organization: $('#org').val(),
			Help: $('#help').val(),
			Comments: $('#comments').val(),
		};

		$.ajax({
			type: 'POST',
			data: JSON.stringify(data),
			url: '/api/try/send-contact-us-form',
			contentType: 'application/json',
			success: function () {
				alert('The form was submitted successfully.');
				$('#contactMeModal').modal('hide');
				loadForm();

			},
			error: function () {
				alert('There was an error submitting the form. Please try again.');
				$('#contactMeModal').modal('hide');
				loadForm();
			}
		})
	});

	function loadForm() {
		if (initialContactMeState.SolutionName === "ShareBase") {
			$('#email-field').css('display', 'block');
			$('#btnSubmit').attr("id", "btnSend");
		}
		$.get('/api/try/get-contact-us-form', function (response) {
			$('#first').val(response.FirstName);
			$('#last').val(response.LastName);
			$('#name').val(response.FirstName + ' ' + response.LastName);
			$('#email').val(response.Email);
			$('#phone').val(response.Phone);
			$('#sfPhone').val(response.Phone);
			$('#org').val(response.Organization);
			$('#comments').val('');
			$('#bodyLoading').hide();
			$('#bodyForm').show();
			$('#footer').show();
			$('#btnSubmit').prop('disabled', '');
			$('#btnCancel').prop('disabled', '');
		});
	}
});
